import { createAction } from 'redux-act'

import { OrderTotals } from '../types'

export const setOrderTotals = createAction<OrderTotals>('set order totals')
